import type { MouseEvent } from 'react';
import { createContext } from 'react';

const noop = (...args: any[]): any => {};

interface ContextValue {
  anchorEl: HTMLElement | null;
  onMenuEnter: (event: MouseEvent<HTMLElement>) => void;
  onMenuLeave: (event: MouseEvent<HTMLElement>) => void;
  onTriggerEnter: (event: MouseEvent<HTMLElement>) => void;
  onTriggerLeave: (event: MouseEvent<HTMLElement>) => void;
  // Keyboard support (WCAG 2.1.1): the hover primitive also exposes an explicit
  // toggle (Enter/Space/ArrowDown) and a close (Escape / backdrop) path.
  onTriggerToggle: (event: MouseEvent<HTMLElement>) => void;
  onClose: () => void;
  open: boolean;
}

export const DropdownContext = createContext<ContextValue>({
  anchorEl: null,
  onMenuEnter: noop,
  onMenuLeave: noop,
  onTriggerEnter: noop,
  onTriggerLeave: noop,
  onTriggerToggle: noop,
  onClose: noop,
  open: false,
});
